import React, { useEffect, useState } from 'react'

/* Atoms */
import Button from 'components_new/atoms/Button'
import ListItemText from 'components_new/atoms/List/ListItemText'
import MenuItem from 'components_new/atoms/Menu/MenuItem'
import TextField from 'components_new/atoms/TextField'

/* Molecules */
import SimpleDialog from 'components_new/molecules/SimpleDialog'

/* Actions */
import { useApiKeyActions } from 'redux/actions/ApiKeys'

/* Hooks */
import { useTranslation } from 'language/translator'

/* Types */
import { ApiKeyType } from 'types/GlobalApiKey'

interface CreateApiKeyDialogProps {
  /**
   * If set, the type selector will be hidden and this type will be used.
   */
  fixedType?: ApiKeyType
  onClose: () => void
  open: boolean
}

const CreateApiKeyDialog = (props: CreateApiKeyDialogProps) => {
  const { fixedType, onClose, open } = props

  const [name, setName] = useState<string>('')
  const [type, setType] = useState<ApiKeyType>(
    fixedType ?? ApiKeyType.DASHBOARD
  )

  useEffect(() => {
    if (open) {
      setName('')
    }
  }, [open])

  const { tryCreateApiKey } = useApiKeyActions()
  const { t, translateEnum } = useTranslation()

  return (
    <SimpleDialog
      actions={
        <>
          <Button variant="text" onClick={onClose}>
            {t('global', 'close')}
          </Button>
          <Button
            disabled={!name}
            variant="contained"
            size="large"
            onClick={() => {
              tryCreateApiKey({ name: name, type: type })

              onClose()
            }}
          >
            {t('global', 'create')}
          </Button>
        </>
      }
      onClose={onClose}
      open={open}
      title={t('api_keys', 'create_key')}
    >
      <TextField
        label={t('global', 'name')}
        helperText={t('api_keys', 'name_helper')}
        required={true}
        autoComplete="off"
        value={name}
        onChange={(event) => setName(event.target.value)}
        sx={{ marginTop: 0, marginBottom: 0 }}
      />

      {!fixedType ? (
        <TextField
          label={t('api_keys', 'key_type_label')}
          select={true}
          value={type}
          sx={{ mt: 2 }}
        >
          {Object.values(ApiKeyType).map((option, i) => {
            const translatedType = translateEnum('api_key_types', option)

            return (
              <MenuItem value={option} key={i} onClick={() => setType(option)}>
                <ListItemText
                  primary={translatedType.title}
                  secondary={translatedType.body}
                  secondaryTypographyProps={{
                    color: 'text.secondary'
                  }}
                />
              </MenuItem>
            )
          })}
        </TextField>
      ) : null}
    </SimpleDialog>
  )
}

export default CreateApiKeyDialog
